const jobs = [
  {
    title: "No Connection",
    color: "#673AB7",
    title_color: "#FAFAFA",
    subtitle: "Could not connect to ResLife Portal system",
    endpoints: [
      {
        route: "",
      },
    ],
    card_actions: [
      {
        title: "",
        icon: "",
      },
    ],
  },
];

export default jobs;



// WEBPACK FOOTER //
// ./app/data/jobs.js